﻿const ajaxTableAttribute = 'data-ajax-table="section"';
const ajaxTableSelector = `[${ajaxTableAttribute}]`;
const ajaxTableAdd = 'data-ajax-table="add"';
const ajaxTableAddSelector = `[${ajaxTableAdd}]`;
const ajaxTableParameterSelector = '[data-ajax-table-parameter]';
const ajaxTableRemove = 'data-ajax-table="remove"';
const ajaxTableRemoveSelector = `[${ajaxTableRemove}]`;
const ajaxTableCallback = 'data-ajax-callback';
const ajaxTableCallbackSelector = `[${ajaxTableCallback}]`;

const ajaxTables = document.querySelectorAll(ajaxTableSelector);

ajaxTables.forEach((ajaxTable, index, parent) => {
  initRemoveButtons(ajaxTable);
  initAddButtons(ajaxTable);
});

function initAddButtons(ajaxTable) {
  let addButtons = ajaxTable.querySelectorAll(ajaxTableAddSelector);

  addButtons.forEach((addButton, index, parent) => {
	addButton.addEventListener('click', function (event) {
	  event.preventDefault();
	  event.stopPropagation();

	  let url = this.dataset.ajaxUrl;

	  let data = new FormData();
	  let parameters = ajaxTable.querySelectorAll(ajaxTableParameterSelector)
	  parameters.forEach((parameter, index, parent) => {
		data.append(parameter.attributes.name.value, parameter.value);
	  });

	  fetch(url, {
		method: 'POST',
		headers: { 'RequestVerificationToken': ajaxTable.dataset.ajaxToken },
		body: new URLSearchParams(data)
	  })
		.then(response => response.text())
		.then(data => {
		  var template = document.createElement('template');
		  template.innerHTML = data.trim();
		  let tbody = ajaxTable.querySelector('table tbody');

		  let position = ajaxTable.dataset.ajaxPosition;
		  if (!position)
			position = 'bottom';

		  switch (position) {
			case 'top':
			  tbody.prepend(template.content);
			  break;
			case 'bottom':
			default:
			  tbody.appendChild(template.content);
			  break;
		  }
		  resetParameters(ajaxTable)
		  initRemoveButtons(ajaxTable);
		  checkEmptyTable(ajaxTable);
		  checkCallback(ajaxTable);
		});
	});
  });
}

function checkCallback(ajaxTable) {
  let callbackFunction = ajaxTable.dataset.ajaxCallback;

  if (callbackFunction) {
	app.executeFunctionByName(callbackFunction, window);
  }
}

export function initRemoveButtons(ajaxTable) {
  let removeButtons = ajaxTable.querySelectorAll(ajaxTableRemoveSelector);

  removeButtons.forEach((button, index, parent) => {
	button.addEventListener('click', function (event) {
	  event.preventDefault();
	  event.stopPropagation();

	  let tr = this.closest('tr');
	  tr.remove();

	  checkEmptyTable(ajaxTable);
	  checkCallback(ajaxTable);
	});
  });
}

export function checkEmptyTable(ajaxTable) {
  let empty = ajaxTable.querySelector('table tfoot');
  if (ajaxTable.querySelectorAll('table tbody tr').length == 0) {
	empty.classList.remove('hidden');
  } else {
	empty.classList.add('hidden');
  }
}

function resetParameters(ajaxTable) {
  let parameters = ajaxTable.querySelectorAll(ajaxTableParameterSelector)
  parameters.forEach((parameter, index, parent) => {
	if (parameter.dataset.ajaxTableParameter !== 'required') {
	  parameter.value = null;
	  if (parameter.slim) {
		parameter.slim.set('');
	  }
	}
  });
}